"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STREAM = exports.RECORDING = void 0;
var STREAM = exports.STREAM = 'stream';
var RECORDING = exports.RECORDING = 'recording';